<template>
<el-row class="screen-container">
    <MuteNotification :jitsiApi="jitsiApi"/>
    <div v-if="!isBreakoutRoomsHidden" @click="hideBreakouts" class="mobile-overlay" :class="[isBreakoutRoomsHidden ? 'hidden' : 'visible']">
        <span class="overlay-close-icon" @click="hideBreakouts"><span>+</span></span>
    </div>
    <el-col style="width:100%;" class="stretch-and-stretch">
    <!-- <jitsi-mobile :vf-room-name="room.name" :jitsi-room-name="room.name.toLowerCase() == room.urlID.toLowerCase() ? room.name : room.urlID" v-if="this.isMobile"></jitsi-mobile> -->
        <div style="width:100%" :class="{'position-iframe': enableIframeIndex }" class="stretch-and-stretch" id='jitsi-iframe' v-loading="loading" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
        </div>
    </el-col>
    <div class="room-timer__wrapper" :class="{'set-room-timer-mute-bar-visible': isMuteBarVisible}" v-if="room.timer">
        <div class="room-timer">
            <div class="room-timer__text">Room timer</div>
            <div class="room-timer__timer">
                <TimerClock :timer="room.timer" @timeout="handleTimeout" />
            </div>
        </div>
    </div>
    <div class="screen-toolbar" :class="{'shift-left-200': !tileViewEnabled && filmStripVisible }">
        <div class="tool__wrapper" @click="toggleTileView" v-if="room.participants && room.participants.length > 1">
            <div class="tool__btn">
                <IconBase
                    v-if="tileViewEnabled"
                    :height="24"
                    :width="24"
                    :view-box="`0 0 24 24`"
                    :fill="'#50C6DF'"
                >
                    <IconSpeakerView />
                </IconBase>
                <IconBase
                    v-else
                    :height="24"
                    :width="24"
                    :view-box="`0 0 24 24`"
                    :fill="'#50C6DF'"
                >
                    <IconTilesView />
                </IconBase>
            </div>
        </div>
        <div class="tool__wrapper" @click="toggleFullScreen" v-if="!this.isSafariOrIos">
            <div class="tool__btn">
                <IconBase
                    :height="24"
                    :width="24"
                    :view-box="`0 0 24 24`"
                    :fill="'#50C6DF'"
                >
                    <IconFullscreen />
                </IconBase>
            </div>
        </div>
    </div>
    <!-- <div class="participant-toolbar" :class="{'small': !filmStripVisible}" v-if="!tileViewEnabled">
        <div v-if="filmStripVisible" class="participant-toolbar--title">Participants</div>
        <div class="arrow" :class="[filmStripVisible ? 'right' : 'left']" @click="toggleFilmStrip">
            <IconBase
                :width="24"
                :height="24"
                :view-box="`0 0 24 24`"
                :fill="'#E7E6FA'"
            >
                <IconAngleDown />
            </IconBase>
        </div>
        <div v-if="!filmStripVisible">
            <i class="el-icon-s-custom"></i>
        </div>
    </div> -->
</el-row>
</template>

<script>
import IconBase from '../IconBase'
import IconFullscreen from '../icons/IconFullscreen'
import IconTilesView from '../icons/IconTilesView'
import IconSpeakerView from '../icons/IconSpeakerView'
import IconAngleDown from '../icons/IconAngleDown'
import TimerClock from '../timer/TimerClock'
import {
    mapState
} from "vuex";
import { playAudio } from '../../utils'
import MuteNotification from './MuteNotification.vue';

export default {
    props: ['jitsiApi', 'tileViewEnabled', 'filmStripVisible'],
    name: "Screen",
    components: {
        TimerClock,
        IconBase,
        IconFullscreen,
        IconTilesView,
        IconSpeakerView,
        // eslint-disable-next-line vue/no-unused-components
        IconAngleDown,
        MuteNotification
    },
    computed: {
        isSafariOrIos: function () {
            var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
               navigator.userAgent &&
               navigator.userAgent.indexOf('CriOS') == -1 &&
               navigator.userAgent.indexOf('FxiOS') == -1;
            var isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            return isSafari || isIos;
        },
        isMobile: function () {
            const {
                userAgent
            } = navigator;
            if (userAgent.match(/Android/i)) {
                return true;
            } else if (userAgent.match(/iP(ad|hone|od)/i)) {
                return true;
            } else {
                return false;
            }
        },
        ...mapState({
            room: state => state.rooms.currentRoom,
            loading: state => state.rooms.loading,
            isBreakoutRoomsHidden: state => state.rooms.isBreakoutRoomsHidden,
            enableIframeIndex: state => state.rooms.enableIframeIndex,
            isMuteBarVisible: state => state.rooms.isMuteBarVisible
        }),
    },
    methods:{
        toggleFullScreen(){
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen();
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
            }
        },
        toggleTileView(){
            this.jitsiApi.executeCommand('toggleTileView');
        },
        toggleFilmStrip(){
            this.jitsiApi.executeCommand('toggleFilmStrip')
        },
        handleTimeout(){
            playAudio()
        },
        hideBreakouts(){
            if(this.isBreakoutRoomsPinned) return;
            this.$store.commit('rooms/hideBreakoutRooms')
        }
    }
}
</script>

<style scoped>
.room-timer__wrapper {
    position:absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 2px;
    min-width: 100%;
}

.room-timer__text {
    font-size: 12px;
    line-height: 15px;
    color: #fff;
    margin-right: 35px;
}
.room-timer {
    display: flex;
    background-color: #0D0C14;
    justify-content: center;
    align-items: center;
    padding: 7px 8px 6px 8px;
    border-radius: 2px;
}
>>>.timer {
    color: #fff;
}
>>>.timer-text{
    font-size: 12px !important;
    line-height: 20px !important;
}
.screen-toolbar {
    position: absolute;
    top: 60px;
    right: 80px;
    width: 72px;
    display: flex;
    justify-content: flex-end;
    transition: all ease-in .3s;
}

.screen-toolbar.shift-left-200 {
    right: 150px;
}

.participant-toolbar {
    position: absolute;
    top: 85px;
    right: 0px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    width: 124px;
    height: 48px;
    color: #E7E6FA;
    background: #1C1C29;
    transition: all ease-in .5s;
}

.participant-toolbar.small {
    width: 52px;
    border-radius: 9px 0 0 9px;
}

.participant-toolbar--title {
    padding: 0 8px;
}

.tool__wrapper {
    height: 24px;
    width: 24px;
    padding: 4px;
    background: #1C1C29;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 2px;
    margin-top: 24px;
}
.arrow {
    padding: 0 2px;
}

.arrow.right {
    transform: rotate(-90deg);
}

.arrow.left {
    transform: rotate(90deg);
}

.screen-container{
    position: relative;
}
.mobile-overlay{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: none;
    background: rgba(174, 170, 250, 0.57);
    z-index: 10;
}

.mobile-overlay.visible{
    z-index: 13;
}

.overlay-close-icon{
    margin: 7px 0 0 6px;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    font-size: 36px;
    background: white;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.overlay-close-icon span{
    transform: rotate(45deg);
}
.set-room-timer-mute-bar-visible {
    top: 46px;
}

.stretch-and-stretch {
    display: flex;
    flex-direction: column;
    flex: auto;
}

@media (max-width: 767px) {
    .mobile-overlay{
        display: block;
    }
    .room-timer__wrapper {
        justify-content: flex-start;
    }
    .set-room-timer-mute-bar-visible {
        top: 46px;
        justify-content: flex-start;
    }
}

@media (hover: none) {
    .mobile-overlay{
        display: block;
    }
    .room-timer__wrapper {
        justify-content: flex-start;
    }
    .set-room-timer-mute-bar-visible {
        top: 46px;
        justify-content: flex-start;
    }
}


</style>